// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/bloom_downsample.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'bloom_downsamplePixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform mediump sampler2D sourceSampler;
uniform vec2 direction;
uniform float uvScale;
#ifdef ENABLE_FILTERING
uniform vec2 luminanceRange;
uniform float luminanceRangeExponent;
uniform mediump sampler2D depthInput;
#endif
float get_luminance(vec3 rgb) {
return dot(rgb, vec3(0.2126, 0.7152, 0.0722));
}
void main(void)
{
vec2 baseUv = uvScale * gl_FragCoord.xy;
vec4 result = vec4(0.0);
for (float x = 0.0; x < float(DOWNSAMPLE_FACTOR); x++) {
ivec2 texelUv = ivec2(baseUv + (x - float(DOWNSAMPLE_FACTOR) * 0.5) * direction);
vec4 texel = texelFetch(sourceSampler, texelUv, 0);
#ifdef ENABLE_FILTERING
float luminance = get_luminance(texel.rgb);
texel *= pow(clamp((luminance - luminanceRange.x) / (luminanceRange.y - luminanceRange.x), 0.0, 1.0), luminanceRangeExponent);
texel /= max(1.0, luminance / luminanceRange.y);
texel *= 0.1;
texel *= 1.0 - step(1.0, texelFetch(depthInput, texelUv, 0).r);
#endif
result += texel;
}
gl_FragColor = result / float(DOWNSAMPLE_FACTOR);
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const bloom_downsamplePixelShader = { name, shader };
//# sourceMappingURL=bloom_downsample.fragment.js.map